import commonText from './commonText';

const demoModes = {
  digital_dsp_display: {
    displayLabel: 'DSP Display',
    initialSelected: false,
    initialImpactFactor: 0.05,
    initialDiscount: 0.75,
    costText: '(average CPM across campaign)',
    costTooltip: '(average CPM across campaign)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'desktop',
  },
  digital_dsp_video: {
    displayLabel: 'DSP Video',
    initialSelected: false,
    initialImpactFactor: 0.1,
    initialDiscount: 0.75,
    costText: '(average CPM across campaign)',
    costTooltip: '(average CPM across campaign)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'desktop',
  },
  digital_inapp: {
    displayLabel: 'In-App Mobile',
    initialSelected: false,
    initialImpactFactor: 0.25,
    initialDiscount: 0.75,
    costText: '(average CPM across campaign)',
    costTooltip: '(average CPM across campaign)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'mobile',
  },
  snapchat: {
    displayLabel: 'Snapchat',
    initialSelected: false,
    initialImpactFactor: 0.2,
    initialDiscount: 0.5,
    costText: '(Expected API CPM)',
    costTooltip: '(Expected CPM for Snapchat Partners API video/Snap Ads)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'mobile',
  },
  youtube: {
    displayLabel: 'Youtube',
    initialSelected: false,
    initialImpactFactor: 0.1,
    initialDiscount: 0.75,
    costText: '(Expected TrueView Cost Per View)',
    costTooltip: '(Expected TrueView Cost Per View)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'youtube',
  },
};

export default demoModes;
